import React from 'react';

import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Provider } from '../../../app/models/Provider';
import { RouteSegmentDataForm } from '../../../app/models/RouteSegment';
import { Place } from '../../../app/models/Place';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import RouteSegmentForm from './forms/RouteSegmentForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    routeSegmentForm: RouteSegmentDataForm;
    setRouteSegmentForm: (routeSegment: RouteSegmentDataForm) => void;
    origins: Place[];
    destinations: Place[];
    currencies: Currency[];
    units: Unit[];
    errorFields?: any;
}

const RouteSegmentFormContainer = ({
    fetching,
    action,
    cancel,
    routeSegmentForm,
    setRouteSegmentForm,
    origins,
    destinations,
    currencies,
    units,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <RouteSegmentForm
                        routeSegmentForm={routeSegmentForm}
                        setRouteSegmentForm={setRouteSegmentForm}
                        origins={origins}
                        destinations={destinations}
                        currencies={currencies}
                        units={units}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default RouteSegmentFormContainer;
